type ApiErrorToastHandler = (message: string) => void;

let showApiErrorToast: ApiErrorToastHandler | null = null;

export function registerApiErrorToast(handler: ApiErrorToastHandler): void {
  showApiErrorToast = handler;
}

export function unregisterApiErrorToast(): void {
  showApiErrorToast = null;
}

export function notifyApiError(message: string): void {
  showApiErrorToast?.(message);
}
